module.exports = __webpack_public_path__ + "img/8_decent_work_and_economic_growth.e1b3f928.svg";